<div class="configure-app">
  <div
    class="global"
  >
    <h2>
      App Settings
    </h2>

    @if (app) {
      <motn-app-global-settings
        [app]="app"
        [patchChildApps]="false"
      ></motn-app-global-settings>
    }
  </div>
</div>
